// extracted by mini-css-extract-plugin
export default {"featuredPosts":"FeaturedPostsList_featuredPosts__kgO8G"};